import { render, staticRenderFns } from "./AccountCenter.vue?vue&type=template&id=a06667c2&scoped=true"
import script from "./AccountCenter.vue?vue&type=script&lang=js"
export * from "./AccountCenter.vue?vue&type=script&lang=js"
import style0 from "./AccountCenter.vue?vue&type=style&index=0&id=a06667c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06667c2",
  null
  
)

export default component.exports